import { dataCut } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCut = /*#__PURE__*/createIcon(dataCut)
export default IconCut
